// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { AuditEventContextAction, ProjectCostList } from '@/audit/api/types';
import { Stack, Typography } from '@mui/material';

interface CostDifference {
  id: string;
  amount: string | null;
  description: string | null;
  isOld: boolean;
  isNew: boolean;
}

interface Props {
  property: ProjectCostList;
  action: AuditEventContextAction;
}

export function AuditProjectCostLabel(props: Props) {
  const costs: CostDifference[] = [];

  props.property.oldValue?.forEach(({ id, amount, description }) => {
    costs.push({ id, amount, description, isOld: true, isNew: false });
  });

  props.property.newValue?.forEach(({ id, amount, description }) => {
    const cost = costs.find((cost) => cost.id === id);

    if (cost === undefined) {
      return costs.push({ id, amount, description, isOld: false, isNew: true });
    }

    cost.isNew = true;
  });

  return (
    <Stack>
      <Typography component="span" variant="caption" fontWeight="bold">
        {props.property.name}:
      </Typography>
      {costs.length > 0 ? (
        costs.map(({ id, amount, description, isNew, isOld }) => {
          if (isNew === isOld) {
            return null;
          }
          return (
            <Typography key={id} variant="caption" marginLeft={2}>
              <Typography component="span" variant="inherit">
                {amount && amount + ' '}
                {description}
              </Typography>
              {props.action !== 'DELETE' && (
                <>
                  {' '}
                  <Typography
                    component="span"
                    variant="inherit"
                    sx={{ textDecoration: 'underline' }}
                  >
                    {isNew ? 'added' : 'removed'}
                  </Typography>
                </>
              )}
            </Typography>
          );
        })
      ) : (
        <Typography variant="caption" marginLeft={2} color="text.secondary">
          None
        </Typography>
      )}
    </Stack>
  );
}
